import { TaskNameId } from 'constants/constants'
import { useEffect } from 'react'
import { terraService } from 'services/terraService'
import { accountStore, taskStore } from 'stores'

export const useBalance = (tokens: string[]) => {
  useEffect(() => {
    accountStore.setTokenInWallet(tokens)
    taskStore.updateTask(terraService.fetchBalance, TaskNameId.balance)
  }, [tokens])
}
